import 'select2'

$('select.multi-select2').select2({
    width: "100%",
    theme: "default",
    // minimumResultsForSearch: -1,
    multiple: true,
    // maximumSelectionLength: 3
});

$('select.select2Search').select2({
    width: "100%",
    theme: "default",
    // minimumResultsForSearch: -1,
});

$('select.select2Simple').select2({
    width: "100%",
    theme: "default",
    minimumResultsForSearch: -1,
}).on('select2:opening', function (e) {
    // Do something
    // var Scope = angular.element(e.currentTarget).scope();
    // var html = $('.select2-container.select2-container--default').html();
    // $('.select2-container.select2-container--default').html(Scope.optionCompile(html));
});

setTimeout(function () {
    $('.select2Search').change();
}, 100);

// on first focus (bubbles up to document), open the menu
// $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
//     $(this).closest(".select2-container").siblings('select:enabled').select2('open');
// });

// $('#new-address-country').on('focus', function(){
//     console.log('focused', $(this));
//     // $(this).find('.select2-selection.select2-selection--single').closest(".select2-container").siblings('select:enabled').select2('open');
// })

// steal focus during close - only capture once and stop propogation
// $('select.select2Search').on('select2:closing', function (e) {
//     $(e.target).data("select2").$selection.one('focus focusin', function (e) {
//         e.stopPropagation();
//     });
// });

// // logging info
// $('.select2-selection').on('focus blur', LogFocusEvent);
// $('.select2.select2-container').on('keydown keyup', LogKeyEvent);
// $('.select2.select2-container').on('click', LogMouseEvent);
// $('select.select2Search').on('select2:open select2:closing select2:close', LogSelect2Event);

// function LogKeyEvent(e) {
//     var KEYS = {
//         "9": "Tab",
//         "13": "Enter"
//     }
//     if (KEYS[e.which]) {
//         console.log("%c " + KEYS[e.which] + " " + e.type + " event ", "background:blue; color:white", e)
//     }
// }

// function LogFocusEvent(e) {
//     console.log("%c " + e.type + " event ", "background:green; color:white", e)
// }

// function LogMouseEvent(e) {
//     console.log("%c " + e.type + " event ", "background:blue; color:white", e)
// }

// function LogSelect2Event(e) {
//     console.log("%c " + e.type + " event ", "background:darkorange; color:white", e)
// }